module.exports = __webpack_public_path__ + "media/images/pic/courses/benefit02-d8f4ab1fa019c5a415e0778f6a4c60b4.svg";